import React from 'react';

const CaracteristicasPisoCaucho = () => {
  return (
    <section>
      <div className="container">
        <div className="row align-items-end mb-2-9 mb-lg-10">
          <div className="col-lg-5 col-xl-6 col-xxl-7 mb-1-6 mb-lg-0">
            <div className="w-xxl-70">
              <span className="text-secondary text-uppercase small letter-spacing-4 d-block mb-2 font-weight-700">
                Uso en interior y exterior
              </span>
              <h2 className="mb-0 display-5 font-weight-700">
                Características<strong className="fst-italic"> Piso de Caucho </strong>
              </h2>
            </div>
          </div>
          <div className="col-lg-7 col-xl-6 col-xxl-5">
            <div className="d-flex bg-primary py-1-6 py-sm-1-9 px-1-6 px-md-2-6 lh-1 rounded">
              <div className="row g-0">
                <CaracteristicaInfo titulo="Año de Garantía" valor="1" delay="200ms" />
                <CaracteristicaInfo titulo="Años de vida útil" valor="10" delay="300ms" />
              </div>
            </div>
          </div>
        </div>

        {/* Características adicionales */}
        <div className="row mt-n1-9">
          <CaracteristicaItem
            imgSrc="/assets/img/icons/icon-flecha-derecha.png"
            titulo="Fácil instalación"
            descripcion="Al ser un piso modular, se adapta a cualquier superficie plana."
            delay="200ms"
          />
          <CaracteristicaItem
            imgSrc="/assets/img/icons/icon-flecha-derecha.png"
            titulo="Alta durabilidad"
            descripcion="Diseñado para resistir el uso rudo y el tráfico pesado."
            delay="300ms"
          />
          <CaracteristicaItem
            imgSrc="/assets/img/icons/icon-flecha-derecha.png"
            titulo="Medidas 50x50cm:"
            descripcion="Cada pieza modular tiene dimensiones de 50x50 cm."
            delay="400ms"
          />
          <CaracteristicaItem
            imgSrc="/assets/img/icons/icon-flecha-derecha.png"
            titulo="Uso en interiores y exteriores:"
            descripcion="Ideal para gimnasios en interiores o áreas de juego en exteriores."
            delay="500ms"
          />
        </div>
      </div>
    </section>
  );
};

// Componente para la sección de años de garantía y vida útil
const CaracteristicaInfo = ({ titulo, valor, delay }) => {
  return (
    <div className="col-sm-6 mb-3 mb-sm-0">
      <div className="d-flex align-items-center border-sm-end pe-4 me-4 border-color-light-white-fifty">
        <div className="flex-shrink-0 me-3">
          <div className="font-weight-600 text-white display-9 alt-font">
            <div className="odometer" data-count={valor}>{valor}</div>
          </div>
        </div>
        <div className="flex-grow-1">
          <h6 className="mb-0 w-50 text-uppercase text-white">{titulo}</h6>
        </div>
      </div>
    </div>
  );
};

// Componente para las características individuales
const CaracteristicaItem = ({ imgSrc, titulo, descripcion, delay }) => {
  return (
    <div className={`col-sm-6 col-lg-3 mt-1-9 wow fadeInUp`} data-wow-delay={delay}>
      <div className="pe-md-3 hover-effect">
        <img src={imgSrc} alt={titulo} className="w-60px mb-1-9" />
        <h4 className="mb-4 h5">{titulo}</h4>
        <p className="mb-0 display-30">{descripcion}</p>
      </div>
    </div>
  );
};

export default CaracteristicasPisoCaucho;
